import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import Bandeja_salida from './components/Bandeja_salida';

const Salida = () => (
  <Container className="dashboard">
    <Row>
      <Col md={12}>
      </Col>
    </Row>
    <Row>
      <Bandeja_salida />
    </Row>
  </Container>
);

export default Salida;
